import { defineChain } from "viem";

const DEFAULT_CHAIN_ID = 4663;
const BLOCK_EXPLORER_URL = "https://robinhoodchain.blockscout.com";

function readPositiveInteger(value: string | undefined, fallback: number) {
  const parsedValue = Number(value);
  return Number.isSafeInteger(parsedValue) && parsedValue > 0
    ? parsedValue
    : fallback;
}

const chainId = readPositiveInteger(
  import.meta.env.VITE_WEB3_CHAIN_ID,
  DEFAULT_CHAIN_ID,
);

export const WEB3_RPC_URL =
  import.meta.env.VITE_WEB3_RPC_URL?.trim() ||
  "https://rpc.mainnet.chain.robinhood.com";

export const WEB3_CHAIN = defineChain({
  id: chainId,
  name: "Robinhood Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: [WEB3_RPC_URL] },
  },
  blockExplorers: {
    default: {
      name: "Robinhood Chain Explorer",
      url: BLOCK_EXPLORER_URL,
    },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0,
    },
  },
});
